import styled from "styled-components";

export const ContainerEditarOrden = styled.div`
  @keyframes modalanimation {
    0% {
      opacity: 0;
      bottom: -100px;
    }
    100% {
      opacity: 1;
      bottom: 0px;
    }
  }
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 30px;
  flex-direction: column;
  .container-btn {
    display: flex;
    gap: 20px;
  }
  span {
    font-size: 18px;
    font-weight: bold;
  }

  .container-carrousel {
    width: 100%;
    height: 350px;
  }
  .container-point {
    display: flex;
    width: 100%;
    height: 20px;
    justify-content: center;
    align-items: center;
    gap: 10px;
  }
  .container-flechas {
    display: flex;
    justify-content: space-around;
    align-items: end;
    margin-top: 20px;
  }
  .flechaBtn {
    display: flex;
    align-items: center;
    cursor: pointer;
  }
  .flechaInvertida {
    rotate: 180deg;
  }
`;

export const Img = styled.img`
  width: 100%;
  max-height: 280px;
  object-fit: contain;
  height: 280px;
`;

export const Point = styled.span`
  width: 10px;
  height: 10px;
  background-color: var(--color-grey45);
  border-radius: 50%;
  ${({ active }) =>
    active
      ? `background-color: var(--color-grey90);`
      : ""}
`;
